import { render, staticRenderFns } from "./HomeLayout.vue?vue&type=template&id=459c3a31&"
import script from "./HomeLayout.vue?vue&type=script&lang=ts&"
export * from "./HomeLayout.vue?vue&type=script&lang=ts&"
import style0 from "./HomeLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports